import React from "react";

const Buy = () => {
    return (
        <a className="btn-primary px-[30px] py-[15px] leading-none"
           href={`${process.env.REACT_APP_WHATSAPP_URL}`}>
            COMPRAR
        </a>
    );
};
export default Buy
